var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeactivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 223.61 65.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".f341c0c7-b27c-41ae-a6de-31e91c756094{fill:none;stroke:#89a6df;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b783e925-b82e-4a39-8d51-21fa4b4f37b3",
    "data-name": "Layer 9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f341c0c7-b27c-41ae-a6de-31e91c756094",
    d: "M6.85,58.79,95,7.61a3.64,3.64,0,0,1,3.64,0l78.1,44.54a3.61,3.61,0,0,0,1.81.48l38.24-.07"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivated);
export default __webpack_public_path__ + "static/media/deactivated.526b14ba.svg";
export { ForwardRef as ReactComponent };